export default __webpack_public_path__ + "static/media/video_active.22e65ff6.svg";